module.exports = __webpack_public_path__ + "img/2.b41d6356.png";